// extracted by mini-css-extract-plugin
export default {"container":"PaymentMethods_container__2tT9J"};